import Card from '@components/Card';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import { InquiryRow } from '@models/inquiry';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';

import InquiryBadge from '../InquiryBadge';

interface Props {
    inquiry: InquiryRow;
}

function InquiryItem({ inquiry }:Props) {
    const {
        status, createdAt, title, inquiryId, content,
    } = inquiry;
    return (
        <Link activityParams={{ inquiryId }}
            activityName='InquiryLogActivity'
            css={wrapperCss} >
            <Card>
                <Card.Body>
                    <InquiryBadge status={status} />
                    <Text size='xl' fontWeight='bold' css={titleCss}>
                        {title}
                    </Text>
                    <Text color={colors.gray7} ellipsis>
                        {content}
                    </Text>
                </Card.Body>
                <Card.Footer>
                    <Text color={colors.gray6}>
                        {dayjs(createdAt).format('YYYY.MM.DD')}
                    </Text>
                </Card.Footer>
            </Card>
        </Link>
    );
}

const titleCss = css`
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

const wrapperCss = css`
    width: 100%;
    ${pressActionEffect}
`;

export default InquiryItem;
